module.exports = __webpack_public_path__ + "assets/wave-gradient.c6e90fa7.svg";